export const state = {
  ticket_detail: {}
}
